<template>
  <div>
    <div class="power-grid">
      <component
        :is="power.artwork ? 'button' : 'article'"
        v-for="power in powers"
        :key="power.name"
        class="power-card"
        :class="{ 'power-card--interactive': power.artwork }"
        :type="power.artwork ? 'button' : null"
        :aria-label="power.artwork ? `View ${power.name} artwork` : null"
        @click="openArtwork(power)"
      >
        <img
          v-if="power.artwork"
          class="power-card__artwork"
          :src="$options.filters.mediaSrc(power.artwork)"
          :alt="power.artworkAlt || `${power.name} artwork`"
        >
        <img
          v-if="power.alternateArtwork"
          class="power-card__artwork-preload"
          :src="$options.filters.mediaSrc(power.alternateArtwork)"
          alt=""
          aria-hidden="true"
        >
        <v-icon class="power-icon" aria-hidden="true">{{ power.icon }}</v-icon>
        <h3>{{ power.name }}</h3>
        <p>{{ power.description }}</p>
        <p v-if="power.developerTranslation" class="developer-translation">
          <strong>Developer Translation:</strong> {{ power.developerTranslation }}
        </p>
      </component>
    </div>
    <vue-easy-lightbox
      :visible="Boolean(activeArtwork)"
      :imgs="activeArtwork || []"
      :index="0"
      @hide="activeArtwork = null"
    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'HeroPowerGrid',
  components: { VueEasyLightbox },
  props: {
    powers: {
      type: Array,
      required: true,
    },
  },
  data: () => ({ activeArtwork: null }),
  methods: {
    openArtwork(power) {
      if (!power.artwork) return;
      const images = [
        {
          src: this.$options.filters.mediaSrc(power.artwork),
          title: power.name,
          alt: power.artworkAlt || `${power.name} artwork`,
        },
      ];

      if (power.alternateArtwork) {
        images.push({
          src: this.$options.filters.mediaSrc(power.alternateArtwork),
          title: `${power.name} — seated office-chair pose`,
          alt: `${power.artworkAlt || `${power.name} artwork`} in a seated office-chair pose`,
        });
      }

      this.activeArtwork = images;
    },
  },
};
</script>

<style scoped>
.power-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.power-card {
  appearance: none;
  background: linear-gradient(145deg, rgba(18, 39, 56, 0.88), rgba(8, 13, 20, 0.98));
  border: 1px solid rgba(141, 220, 255, 0.2);
  border-radius: 10px;
  color: inherit;
  font: inherit;
  min-height: 210px;
  padding: 26px;
  position: relative;
  text-align: left;
  transition: border-color 180ms ease, transform 180ms ease;
  width: 100%;
}

.power-card__artwork {
  aspect-ratio: 3 / 2;
  border-radius: 7px;
  display: block;
  margin: -10px -10px 22px;
  object-fit: contain;
  width: calc(100% + 20px);
}

.power-card__artwork-preload {
  height: 1px;
  left: -9999px;
  position: absolute;
  width: 1px;
}

.power-card:hover {
  border-color: rgba(141, 220, 255, 0.6);
  transform: translateY(-3px);
}

.power-card--interactive { cursor: pointer; }
.power-card--interactive:focus-visible {
  border-color: #91e0ff;
  outline: 3px solid #fff;
  outline-offset: 4px;
}

.power-icon {
  color: #91e0ff !important;
  font-size: 2rem !important;
  margin-bottom: 24px;
  text-shadow: 0 0 18px rgba(89, 204, 255, 0.7);
}

.power-card h3 {
  color: #fff;
  font-size: 1.2rem;
  letter-spacing: 0;
  margin: 0 0 12px;
}

.power-card p {
  color: #bdcad3;
  line-height: 1.6;
  margin: 0;
}

.power-card .developer-translation {
  border-top: 1px solid rgba(141, 220, 255, 0.16);
  color: #d9edf5;
  margin-top: 20px;
  padding-top: 16px;
}

.developer-translation strong {
  color: #91e0ff;
}

@media (max-width: 900px) {
  .power-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .power-grid {
    grid-template-columns: 1fr;
  }

  .power-card {
    min-height: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .power-card {
    transition: none;
  }

  .power-card:hover {
    transform: none;
  }
}
</style>
